import React from 'react';
import Collapse from '@mui/material/Collapse';
import { Text, Theme } from '@simplybenefits/sb-ui-library';
import Avatar from "react-avatar";
import * as dates from '@simplybenefits/sb-dates';
import { styled } from '@mui/system';

const StyledTextBlock = styled('div')({
    display: 'flex',
    flex: 1,
    flexDirection: 'column'
});

/**
 * @param item
 * @param type
 * @param doHover
 * @param classes
 * @returns {*}
 * @constructor
 */
const NameTag = ({ item, type, doHover }) => {
    const [ hovered, setHovered ] = React.useState(false);
    const styles = {
        container: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            borderRadius: 10,
            width: 320,
            minHeight: 100,
            maxHeight: 300,
            overflow: 'auto',
            paddingLeft: 20,
            marginRight: 20
        }
    };

    /**
     * @private
     */
    const _toggleHover = () => {
        setHovered((isHovered) => !isHovered);
    };

    let backgroundColor = Theme.colors.mediumLightBlue;

    if (type === 'medium') {
        backgroundColor = Theme.colors.mediumDarkBlue;
    } else if (type === 'dark') {
        backgroundColor = Theme.colors.darkBlue;
    }

    return (
        <div style={{ ...styles.container, backgroundColor: backgroundColor }} onMouseEnter={ _toggleHover } onMouseLeave={ _toggleHover }>
            <Avatar
                name={`${ item.firstname } ${ item.lastname }`}
                size="60"
                textSizeRatio={3}
                round={true}
                style={{ fontWeight: 600, marginRight: 20 }}
                color={ Theme.colors.skyBlue }
            />

            <StyledTextBlock style={ hovered ? { padding: "20px 0" } : null }>
                <Text
                    mediumLarge
                    veryBold
                    color={ Theme.colors.surface }
                >
                    { `${ item.firstname } ${ item.lastname }` }
                </Text>

                <Text
                    medium
                    bold
                    color={ Theme.colors.surface }
                >
                    { item.isSurvivorBenefitParent ? 'Survivor Benefit' : item.relationship }
                </Text>

                {
                    doHover &&
                        <Collapse in={ hovered }>
                            <div>
                                {
                                    item.status &&
                                        <Text
                                            small
                                            bold
                                            color={ Theme.colors.surface }
                                        >
                                            { item.status }
                                        </Text>
                                }

                                {
                                    item.gender &&
                                        <Text
                                            small
                                            bold
                                            color={ Theme.colors.surface }
                                        >
                                            { item.gender }
                                        </Text>
                                }

                                {
                                    item.birthdate &&
                                        <Text
                                            small
                                            bold
                                            color={ Theme.colors.surface }
                                        >
                                            Date of Birth: { dates.getStartOfDay(item.birthdate, 'll') }
                                        </Text>
                                }

                                {
                                    item.email &&
                                        <Text
                                            small
                                            bold
                                            color={ Theme.colors.surface }
                                        >
                                            { item.email }
                                        </Text>
                                }
                            </div>
                        </Collapse>
                }
            </StyledTextBlock>
        </div>
    );
};


export default (NameTag);